import React from 'react';

import SimpleContainer from '../../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../../containers/categorycontainer/CategoryContainer';
import QuoteCarousel from '../../components/quote-carousel/quote-carousel';

import tableImage from '../../media/help-and-guides/highly-validated-table.png';

import author_image_2 from '../../media/author_img_2.jpg';
import author_image_3 from '../../media/author_img_3.jpg';

import 'bootstrap/dist/css/bootstrap.css';
import '../../../ext/font-awesome-4.7.0/css/font-awesome.css';

import { PageText, Categories, Quotes } from '../../input-text/en/help-and-guides/highly-validated_page';

class HighlyValidated extends React.Component {
  constructor(){
      super();
      const images = [author_image_2, author_image_3];
      //attach images to quotes
      Quotes.forEach(quote => {
          quote.image = images[Quotes.indexOf(quote)];
      });
  }

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <i className="icon fa fa-certificate fa-5x" aria-hidden="true"></i>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } />
        <CategoryContainer cols='1' category={ Categories._2 } component={ <img className="no-margin" src={tableImage} alt="A time series of hourly measurements for 3 independent measuring stations in the region of Antwerp in the months of February, May, August and November 2016 is compared with the outcomes of aircheckr" /> } />
        <CategoryContainer cols='1' category={ Categories._3 } />
        <section className="page-section">
            <div className="container">
                <QuoteCarousel quotes={ Quotes } />
            </div>
        </section>
        <CategoryContainer cols='1' category={ Categories._4 } />
      </div>
    );
  }
};

export default HighlyValidated;



// WEBPACK FOOTER //
// ./src/routes/help-and-guides/HighlyValidated.js